module.exports = __webpack_public_path__ + "img/keto.a8c63ea1.jpeg";